<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="anchor"
    [cdkConnectedOverlayOpen]="true"
    cdkConnectedOverlayWidth="100%"
    cdkConnectedOverlayHeight="100%"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayViewportMargin]="viewportMargin"
    cdkConnectedOverlayPanelClass="sidebar-drawer-panel"
>
    <app-sidebar-drawer
        [isOpen]="isOpen"
        (isOpenChange)="isOpenChange.emit($event)"
        [layoutConfig]="layoutPositionConfigItem"
        [trigger]="trigger"
    >
        <app-sidebar-content
            (clickItem)="this.closeSidebar()"
            [padded]="layoutPositionConfigItem.padded"
        ></app-sidebar-content>
    </app-sidebar-drawer>
</ng-template>
